import { CommonModule, DOCUMENT, Location } from '@angular/common';
import { Component, effect, ElementRef, HostListener, Inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterModule } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PERMISSION } from '../constant/permission';
import { PrimeNgModule } from '../shared/prime-ng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProjectService } from '../services/project.service';
import { Select, SelectModule } from 'primeng/select';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    PrimeNgModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  @Input() isLogin = false;
  @ViewChild('pSelect') pSelect!: Select;
  public userRole: any;
  isSliderOpen: boolean = false;
  isUserMenuOpen: boolean = false;
  isPin: boolean = false;
  private routerSubscription: Subscription = new Subscription();
  currentUrl: string = '';
  routeName: string = 'Project Dashboard';
  public commonDataObject = {
    sidebarToggle: false,
    issuccessAlert: false,
    iserrorAlert: false,
    apiMeassge: '',
    uName: '' as any,
    filteredUserMenu: [] as any[],
    selectedProject: null as any
  }
  showBackIcon = false;
  public SuperAdmin = [
    "project_dashboard",
    "dashboard_view",
    "user_creation",
    "master_creation",
    "form_configuration",
    "form_list",
    "form_reports",
    "entry_form",
    "project_details",
    "form_submission",
    "reset_password",
    "project_analytics"
  ];
  public Admin = [
    "user_creation",
    "master_creation",
    "form_configuration",
    "form_list",
    "form_reports",
    "form_submission",
    "project_details",
    "project_dashboard",
    "reset_password"
  ];
  public User = [
    "form_list",
    "form_reports",
    "form_submission",
    // "project_details",
    // "project_dashboard",
    "reset_password"
  ];
  public menuItems = [
    {
      label: 'Project Dashboard',
      icon: 'fa fa-folder',
      route: '/project_dashboard',
      permission: PERMISSION.PROJECT_DASHBOARD,
      requiresProject: false
    },
    {
      label: 'Project List',
      icon: 'fa fa-list-check',
      route: '/dashboard_view',
      permission: PERMISSION.DASHBOARD_VIEW,
      requiresProject: false
    },
    {
      label: 'Project Details',
      icon: 'fa fa-info',
      permission: PERMISSION.PROJECT_DETAILS,
      requiresProject: true,
      route: ['/project_details'],
      queryParams: () => ({
        id: this.commonDataObject.selectedProject?.project_id
      })
    },
    {
      label: 'User Creation',
      icon: 'fa fa-user-plus',
      route: '/user_creation',
      permission: PERMISSION.USER_CREATION,
      requiresProject: false
    },
    {
      label: 'Master Creation',
      icon: 'fa fa-folder-plus',
      route: '/master_creation',
      permission: PERMISSION.MASTER_CREATION,
      requiresProject: true
    },
    {
      label: 'Form Configuration',
      icon: 'fa fa-gears',
      route: '/form_configuration',
      permission: PERMISSION.FORM_CONFIGURATION,
      requiresProject: true
    },
    {
      label: 'Form Submission',
      icon: 'fa fa-pen-to-square',
      route: '/form_submission',
      permission: PERMISSION.FORM_SUBMISSION,
      requiresProject: true
    },
    {
      label: 'Form List',
      icon: 'fa fa-indent',
      route: '/form_list',
      permission: PERMISSION.FORM_LIST,
      requiresProject: true
    },
    {
      label: 'Reports',
      icon: 'fa-solid fa-chart-pie',
      route: '/form_reports',
      permission: PERMISSION.FORM_REPORTS,
      requiresProject: true
    },
    {
      label: 'Analytics',
      icon: 'fa-solid fa-arrow-up-right-dots',
      route: '/project_analytics',
      permission: PERMISSION.PROJECT_ANALYTICS,
      requiresProject: true
    }
    // {
    //   label: 'Entry Form',
    //   icon: 'fa fa-user-plus',
    //   route: '/entry_form',
    //   permission: PERMISSION.ENTRY_FORM,
    //   requiresProject: true
    // }
  ];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    private router: Router,
    public projectService: ProjectService,
    private renderer: Renderer2,
    private location: Location,
    private elementRef: ElementRef) {
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.renderer.addClass(this.document.body, 'collapsed-sidebar');
        this.renderer.removeClass(this.document.body, 'expand-sidebar');
        this.commonDataObject.sidebarToggle = false;
      }
    });
    effect(() => {
      this.commonDataObject.selectedProject = this.projectService.selectedProject();
      this.currentUrl = this.router.url;
      this.userRole = sessionStorage.getItem('user_category_code');
      this.onRouteChange();
      this.filterUserMenu();

      if (!this.commonDataObject.selectedProject) {
        this.setDefaultProject();
      }
    });
    this.currentUrl = this.router.url;
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects || event.url;
        this.onRouteChange();
        let analyticsData: any = this.projectService.getReportData();
        let formListData: any = this.projectService.dynamicEntryFormData();
        if (analyticsData !== null || formListData !== null) {
          this.showBackIcon = true;
        } else {
          this.showBackIcon = false;
        }
      });
    this.setDefaultProject();
    let data: any = this.projectService.getReportData();
    if (data) {
      this.commonDataObject.selectedProject = data?.selected_project
    }
  }

  setDefaultProject() {
    const permittedProjects = this.projectService.getPermittedProjects();
    if (permittedProjects && permittedProjects.length > 0) {
      if (!this.commonDataObject.selectedProject) {
        const firstProject = permittedProjects[0];
        this.commonDataObject.selectedProject = firstProject;
        this.projectService.setSelectedProject(firstProject);
        const projectId = firstProject?.project_id;
        if (projectId) {
          this.projectService.getFormsProjectWise(projectId);
        }
      }
    }
  }

  onRouteChange() {
    this.routeName = this.getRouteName(this.currentUrl);
  }

  getRouteName(url: string): string {
    if (url.includes('/project_dashboard')) return 'Project Dashboard';
    if (url.includes('/dashboard_view')) return 'Project List';
    if (url.includes('/project_details')) return 'Project Details';
    if (url.includes('/user_creation')) return 'User List';
    if (url.includes('/master_creation')) return 'Master List';
    if (url.includes('/form_configuration')) return 'Form Configuration';
    if (url.includes('/form_list')) return 'Form List';
    if (url.includes('/form_reports')) return 'Form Reports';
    if (url.includes('/form_submission')) return 'Form Submission';
    if (url.includes('/reset_password')) return 'Reset Password';
    if (url.includes('/project_analytics')) return 'Project Analytics';
    if (url.includes('/no-permission')) return '';
    return 'login';
  }

  getQueryParams(menu: any) {
    if (typeof menu.queryParams === 'function') {
      return menu.queryParams();
    }
    return menu.queryParams;
  }

  filterUserMenu() {
    let permissionArray = [];
    this.userRole === 'SUPER_ADMIN' ? permissionArray = this.SuperAdmin : this.userRole === 'ADMIN' ? permissionArray = this.Admin : permissionArray = this.User;
    this.commonDataObject.filteredUserMenu = this.menuItems.filter(menu => {
      if (permissionArray.find(key => key === menu?.permission)) return true;
      return false;
    });
  }

  hasPermission(page_permission: any, permission: string): boolean {
    return page_permission?.includes(permission);
  }

  ngOnChanges(change: any) {
    this.commonDataObject.uName = sessionStorage.getItem('first_name');
  }

  pinUnpinSidebar() {
    this.isPin = !this.isPin;
  }

  onProjectChange(projectDetails: any) {
    this.projectService.setSelectedProject(projectDetails);
    this.commonDataObject.selectedProject = projectDetails;
    if (this.userRole === 'USER') {
      this.projectService.setChangesProject(true);
      this.router.navigate(['/form_submission'])
    } else {
      this.router.navigate(['/project_details'], {
        queryParams: { id: projectDetails?.project_id }
      });
    }
    const projectId = this.projectService.selectedProject()?.project_id;
    if (projectId) {
      this.projectService.getFormsProjectWise(projectId);
    }
  }

  logoutApp() {
    this.authService.logoutFromAll().subscribe((res: any) => {
      if (res && res.code === "CSR_MS_OK_200") {
        this.authService.destroyStorage();
        this.isLogin = false;
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.issuccessAlert = true;
        this.isUserMenuOpen = false;
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 200);
      }
      else {
        this.commonDataObject.apiMeassge = res.message;
        this.commonDataObject.iserrorAlert = true;
      }
      setTimeout(() => {
        this.commonDataObject.issuccessAlert = false;
        this.commonDataObject.iserrorAlert = false;
      }, 4000);
    });
  }


  resetPw() {
    this.isUserMenuOpen = false;
    this.router.navigate(['/reset_password']);
  }

  toggleUserMenu(event: any): void {
    event.stopPropagation();
    this.pSelect.hide();
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const headerRight = document.getElementById('userAccount');
    if (headerRight && !headerRight.contains(event.target as Node)) {
      this.isUserMenuOpen = false;
    }
  }

  openSidebar(): void {
    setTimeout(() => {
      if (!this.isSliderOpen) {
        this.isSliderOpen = true;
      }
    }, 100)
  }

  closeSidebar(): void {
    if (!this.isPin) {
      this.isSliderOpen = false;
    }
  }

  backToAnalitycs() {
    this.location.back();
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

}
